import React, {useState} from "react";
import {Form, Input} from "antd";
import {FormattedMessage} from "react-intl";
import transcoding from '@api/transcoding'
import {validSubtitleFileExtensions} from "./core/validFileExtensions";


const SubTitleInput = ({form, subtitles, addFile}) => {

  const validateFtpPath = (rule, value, callback) => {
    const path = value.trim();

    if (!!path) {
      const extention = path.split(".").pop()

      if (subtitles.find(item => item.path === path)) {
        callback(
          <FormattedMessage
            id="file_is_added"
            defaultMessage={`File has been added`}/>);
      }
      else if (!validSubtitleFileExtensions.includes(extention)) {
        callback(
          <FormattedMessage
            id="invalid_audio_file_extension"
            defaultMessage={`File extension is invalid!`}/>);
      }
      else {
        transcoding.getFile({params: {path}})
          .then(({data}) => {
            const {audios, ...rest} = data;
            addFile({...rest, path})
            form.resetFields()
            if (!data) {
              callback(
                <FormattedMessage
                  id="app.invalid_file_path"
                  defaultMessage={`File path is invalid`}/>);
            } else {
              callback();
            }
          })
          .catch(error => callback(<FormattedMessage
            id="app.invalid_file_path"
            defaultMessage={`File path is invalid`}/>));
      }

    } else {
      callback();
    }
  };

  return (
    <Form style={{padding: "10px"}}>
      <Form.Item label={<FormattedMessage
        id="add_subtitle"
        defaultMessage={`Add subtitle`}/>}>
        {form.getFieldDecorator("relative_ftp_path", {
          rules: [{
            whitespace: true,
            required: true,
            message: (
              <FormattedMessage
                id="app.ftp_path_is_required"
                defaultMessage={`FTP path is required`}
              />
            )
          }, {
            validator: validateFtpPath
          }]
        })(
          <Input className={"url-input"}/>
        )}
      </Form.Item>
    </Form>
  )
}


export default Form.create({name: "subtitlefile-input"})(SubTitleInput)

